import styled from 'styled-components'

export const Container = styled.div``

export const HeaderBox = styled.div`
    background-image: url(${(props) => props.backgroundImage});
    margin-bottom: 30px !important;
    position: relative !important	;
`
